import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { CheckboxVisibility, DetailsList, DetailsListLayoutMode, DetailsRow, Selection, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { Slider } from 'office-ui-fabric-react/lib/Slider';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { getTheme } from 'office-ui-fabric-react/lib/Styling';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import PerimetreContext from '../../contexts/PerimetreContext';
import { DataLot } from '../../data/DataLot';
import { DataLotCommercial } from '../../data/DataLotCommercial';
import { DataOperation } from '../../data/DataOperation';
import { DataReservation } from '../../data/DataReservation';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxEtage } from '../ComboBox/ComboBoxEtage';
import { ComboBoxExposition } from '../ComboBox/ComboBoxExposition';
import { ComboBoxLotType } from '../ComboBox/ComboBoxLotType';
import { ComboBoxNature } from '../ComboBox/ComboBoxNature';
import { EUIComboBox } from '../EUI/EUIComboBox';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { EUITextField } from '../EUI/EUITextField';
import { FicheGrilleDePrix_LotCommercial as FicheGrilleDePrixLotCommercial } from '../Fiche/FicheGrilleDePrix_LotCommercial';
import { FicheLot } from '../Fiche/FicheLot';
import { FicheLotCommercialHistorique } from '../Fiche/FicheLotCommercialHistorique';
import { FicheLotCommercialSuppression } from '../Fiche/FicheLotCommercialSuppression';
import { FicheReservation } from '../Fiche/FicheReservation';
import '../List/DetailsListGrilleDePrix.css';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

const theme = getTheme();

var objetState = {
    items: [],
    groupeLotCommercial: [],
    optLotsCommerciaux: [],
    selectedLotCommercial: {
        idLotCommercial: 0,
        statut: null
    },
    selectedLot: {},
    desistement: {},
    idReservation: 0,
    nbEnregistrement: 0,

    nbLotsParNature: 0,
    calculAAppliquer: {
        signe: '+',
        valeur: 0,
        action: 'Valeur'
    },
    actionAssociation: 'Nouveau',

    peutModifierOperation: false,
    peutDissocierLotUnitaire: false,
    peutVisualiserFicheLotCommercial: false,
    peutAssocierLotUnitaireVersLotCommercial: false,
    peutDissocierLotUnitaireVersLotCommercial: false,
    possedeLotCommercialVide: false,

    onAffichePanelGrilleDePrix_LotCommercial: false,
    onAffichePanelLotCommercialHistorique: false,
    onAffichePanelFicheDetailLotCommercial: false,
    onAffichePanelFicheLot: false,
    onAffichePanelFicheReservation: false,
    onAffichePanelFiltre: false,
    onAffichePanelSuppressionLotCommercialVide: false,

    onAfficheDialogSuppression: false,
    onAfficheDialogMiseEnVenteLotsCommerciaux: false,
    onAfficheDialogRetirerVenteLotsCommerciaux: false,
    onAfficheDialogAssocierLot: false,
    onAfficheDialogDissocierLot: false,
    onAfficheDialogRegrouperLot: false,
    onAfficheDialogDegrouperLot: false,
    onAfficheDialogModificationImpossible: false,
    onAfficheDialogDissocierLotEtSupprimerLotCommercial: false,
    onAfficheDialogDesistement: false,

    //filtreParNature: false,

    filtreIdNature: 0,
    filtreIdLotType: 0,
    filtreStatut: '0',
    filtreNumLot: null,
    filtreSHA: 300,
    filtreEtage: 0,
    filtreExposition: 0,
    filtreBudget: 1000000,

    enCoursDeTraitement: false,
    messageEnCoursDeTraitement: '',
    hideMessageBarFiltres: true,
    hideMessageBarWarning: true,
    hideMessageBarError: true,
    messageMessageBarFiltres: '',
    warningMessage: '',
    errorMessage: '',
    messageModificationImpossible: ''
}

export class DetailsListGrilleDePrix extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListGrilleDePrixWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListGrilleDePrixWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    _creationContent() {
        const { items, groupeLotCommercial } = this.state;

        return (<DetailsList
            setKey="items"
            items={items}
            groups={groupeLotCommercial}
            groupProps={{
                isAllGroupsCollapsed: true,
                showEmptyGroups: true,
                onRenderHeader: this._onRenderGroupHeader
            }}
            compact={true}
            layoutMode={DetailsListLayoutMode.justified}
            onRenderDetailsHeader={this._onRenderDetailsHeader}
            columns={this.columnsLot}
            selection={this._selection}
            selectionMode={SelectionMode.multiple}
            checkboxVisibility={CheckboxVisibility.always}
        />);
    }

    constructor(props) {
        super(props);

        this._selection = new Selection({
            onSelectionChanged: () => {
                this.setState({ selectedLots: this._selection.getSelection() });
            }
        });

        this._headerGroups = [];

        this.state = objetState;

        // il faut le même nombre de colonnes et les mêmes tailles pour les deux tableaux pour que les colonnes soient alignées verticalement
        //#region chargement des colonnes lots
        let columnsTempLot = [];

        columnsTempLot.push({
            key: 'statut',
            name: 'Statut',
            ariaLabel: 'Statut',
            fieldName: 'statut',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            onRender: (item) => {
                return null;
            }
        });
        columnsTempLot.push({
            key: 'numero',
            name: 'N° lot',
            ariaLabel: 'N° lot',
            fieldName: 'numero',
            minWidth: 50,
            maxWidth: 100,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            isResizable: true,
            onRender: (item) => {
                let numLot = item.numero;

                return <span title={numLot}>{numLot}</span>;
            }
        });
        columnsTempLot.push({
            key: 'lotType',
            name: 'Type',
            ariaLabel: 'Type',
            fieldName: 'lotType',
            minWidth: 50,
            maxWidth: 100,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            isResizable: true,
            onRender: (item) => {
                let lotType = item.lotType;

                return <span title={lotType}>{lotType}</span>;
            }
        });
        columnsTempLot.push({
            key: 'etage',
            name: 'Etage',
            ariaLabel: 'Etage',
            fieldName: 'etage',
            minWidth: 45,
            maxWidth: 90,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            isResizable: true,
            onRender: (item) => {
                let etage = item.etage;

                return <span title={etage}>{etage}</span>;
            }
        });
        columnsTempLot.push({
            key: 'batiment',
            name: 'Bât.',
            ariaLabel: 'Bâtiment',
            fieldName: 'batiment',
            minWidth: 45,
            maxWidth: 45,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            isResizable: true,
            onRender: (item) => {
                let batiment = item.batiment;

                return <span title={batiment}>{batiment}</span>;
            }
        });
        columnsTempLot.push({
            key: 'exposition',
            name: 'Expo.',
            ariaLabel: 'Exposition',
            fieldName: 'exposition',
            minWidth: 45,
            maxWidth: 45,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            isResizable: true,
            onRender: (item) => {
                let exposition = item.exposition;

                return <span title={exposition}>{exposition}</span>;
            }
        });
        columnsTempLot.push({
            key: 'surfaceHabitable',
            name: 'SHA',
            ariaLabel: 'SHA',
            fieldName: 'surfaceHabitable',
            minWidth: 40,
            maxWidth: 55,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            isResizable: true,
            onRender: (item) => {
                let SHA = item.surfaceHabitable;

                return <span title={SHA}>{SHA}</span>;
            }
        });
        columnsTempLot.push({
            key: 'quantite',
            name: 'Quantité',
            ariaLabel: 'Quantité',
            fieldName: 'quantite',
            minWidth: 40,
            maxWidth: 55,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            isResizable: true,
            onRender: (item) => {
                let quantite = item.quantite;

                return <span title={quantite}>{quantite}</span>;
            }
        });
        columnsTempLot.push({
            key: 'prixTTC',
            name: 'Prix TTC',
            ariaLabel: 'Prix TTC',
            fieldName: 'prixTTC',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let prixTTC = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.prixTTC).toFixed(2), false, 2);

                return (item.prixTTC !== null ? <span title={`${prixTTC} €`}>{`${prixTTC} €`}</span> : null);
            }
        });
        columnsTempLot.push({
            key: 'prixMaitriseTTC',
            name: 'Prix maîtrisé',
            ariaLabel: 'Prix maîtrisé',
            fieldName: 'prixMaitriseTTC',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let prixMaitriseTTC = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.prixMaitriseTTC).toFixed(2), false, 2);

                return (item.prixMaitriseTTC !== null ? <span title={`${prixMaitriseTTC} €`}>{`${prixMaitriseTTC} €`}</span> : null);
            }
        });
        columnsTempLot.push({
            key: 'loyerAnnuelTTC',
            name: 'Loyer TTC',
            ariaLabel: 'Loyer TTC',
            fieldName: 'loyerAnnuelTTC',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return null;
            }
        });
        columnsTempLot.push({
            key: 'prixMobilierTTC',
            name: 'Prix mobilier',
            ariaLabel: 'Prix mobilier',
            fieldName: 'prixMobilierTTC',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return null;
            }
        });
        columnsTempLot.push({
            key: 'dateAction',
            name: 'Date',
            ariaLabel: 'Date',
            fieldName: 'dateAction',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return null;
            }
        });
        columnsTempLot.push({
            key: 'modifier',
            name: '',
            ariaLabel: 'Modifier',
            fieldName: 'modifier',
            minWidth: 20,
            maxWidth: 20,
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                return (this.state.peutModifierOperation && item.idLot !== null ?
                    <IconButton
                        iconProps={{ iconName: 'Edit' }}
                        title="Modifier"
                        ariaLabel="Modifier"
                        onClick={() => this._onAffichagePanelFicheLot(item)}
                    />
                    : null);
            }
        });

        columnsTempLot.push({
            key: 'ficheChronologique',
            name: '',
            ariaLabel: 'Fiche chronologique',
            fieldName: 'ficheChronologique',
            minWidth: 20,
            maxWidth: 20,
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                return null;
            }
        });
        columnsTempLot.push({
            key: 'regroupement',
            name: '',
            ariaLabel: 'Regroupement',
            fieldName: 'regroupement',
            minWidth: 20,
            maxWidth: 20,
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                return (item.numRegroupement !== null ?
                    <IconButton
                        iconProps={{ iconName: 'Link' }}
                        title={item.numRegroupement}
                        ariaLabel={item.numRegroupement}
                    />
                    : null);
            }
        });

        columnsTempLot.push({
            key: 'desistement',
            name: 'Désistement',
            ariaLabel: 'Désistement',
            fieldName: 'desistement',
            minWidth: 20,
            maxWidth: 20,
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                return null;
            }
        });

        this.columnsLot = columnsTempLot;
        //#endregion

        //#region chargement des colonnes lot commercial (entête)
        let columnsTempLotCommercial = [];

        columnsTempLotCommercial.push({
            key: 'selectionEtExtension',
            name: '',
            ariaLabel: '',
            fieldName: 'selectionEtExtension',
            minWidth: 50,
            maxWidth: 50,
            className: 'celluleEnteteLotCommercial',
            onRender: (item) => {
                return (<div>
                    {item.itemProps.isSelected ?
                        <IconButton
                            iconProps={{ iconName: 'Completed' }}
                            title="Désélectionner tout"
                            ariaLabel="Désélectionner tout"
                            onClick={this._onToggleSelectGroup(item.itemProps)}
                        />
                        :
                        <IconButton
                            iconProps={{ iconName: 'CircleRing' }}
                            title="Sélectionner tout"
                            ariaLabel="Sélectionner tout"
                            onClick={this._onToggleSelectGroup(item.itemProps)}
                        />}
                    {item.itemProps.group.isCollapsed ?
                        <IconButton
                            iconProps={{ iconName: 'ChevronRightMed' }}
                            title="Déplier"
                            ariaLabel="Déplier "
                            onClick={this._onToggleCollapse(item.itemProps)}
                        />
                        :
                        <IconButton
                            iconProps={{ iconName: 'ChevronDownMed' }}
                            title="Replier"
                            ariaLabel="Replier"
                            onClick={this._onToggleCollapse(item.itemProps)}
                        />
                    }
                </div>)
            }
        });
        columnsTempLotCommercial.push({
            key: 'statut',
            name: 'Statut',
            ariaLabel: 'Statut',
            fieldName: 'statut',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            onRender: (item) => {
                let statut = item.statut;

                return <span title={statut}>{(item.verrouille ? <Icon title="Réservation verrouillée" iconName="Lock" /> : null)} {statut}</span>;
            }
        });
        columnsTempLotCommercial.push({
            key: 'numero',
            name: 'N° lot',
            ariaLabel: 'N° lot',
            fieldName: 'numero',
            minWidth: 50,
            maxWidth: 100,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            isResizable: true,
            onRender: (item) => {
                let numero = item.numero;

                return <span title={numero}>{numero}</span>;
            }
        });
        columnsTempLotCommercial.push({
            key: 'lotType',
            name: 'Nb pièces',
            ariaLabel: 'Nb pièces',
            fieldName: 'lotType',
            minWidth: 50,
            maxWidth: 100,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            isResizable: true,
            onRender: (item) => {
                let lotType = item.lotType + (item.lotType > 0 ? ' pièce(s)' : '');

                return <span title={lotType}>{lotType}</span>;
            }
        });
        columnsTempLotCommercial.push({
            key: 'etage',
            name: 'Etage',
            ariaLabel: 'Etage',
            fieldName: 'etage',
            minWidth: 45,
            maxWidth: 90,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            isResizable: true,
            onRender: (item) => {
                let etage = item.etage;

                return <span title={etage}>{etage}</span>;
            }
        });
        columnsTempLotCommercial.push({
            key: 'nbParking',
            name: 'Park.',
            ariaLabel: 'Parking',
            fieldName: 'nbParking',
            minWidth: 45,
            maxWidth: 45,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            isResizable: true,
            onRender: (item) => {
                let nbParking = (item.nbParking !== null ? item.nbParking + ' parking(s)' : null);

                return <span title={nbParking}>{nbParking}</span>;
            }
        });
        columnsTempLotCommercial.push({
            key: 'nbCave',
            name: 'Cave',
            ariaLabel: 'Cave',
            fieldName: 'nbCave',
            minWidth: 45,
            maxWidth: 45,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            isResizable: true,
            onRender: (item) => {
                let nbCave = (item.nbCave !== null ? item.nbCave + ' cave(s)' : null);

                return <span title={nbCave}>{nbCave}</span>;
            }
        });
        columnsTempLotCommercial.push({
            key: 'shaTotale',
            name: 'SHA',
            ariaLabel: 'Surface habitable totale',
            fieldName: 'shaTotale',
            minWidth: 40,
            maxWidth: 55,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            isResizable: true,
            onRender: (item) => {
                let SHA = item.shaTotale;

                return <span title={`${SHA !== null ? SHA + ' m²' : ''}`}>{`${SHA !== null ? SHA + ' m²' : ''}`}</span>;
            }
        });
        columnsTempLotCommercial.push({
            key: 'shaAnnexe',
            name: 'SHA Annexe',
            ariaLabel: 'SHA Annexe',
            fieldName: 'shaAnnexe',
            minWidth: 40,
            maxWidth: 55,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            isResizable: true,
            onRender: (item) => {
                let shaAnnexe = item.shaAnnexe;

                return <span title={`${shaAnnexe !== null ? shaAnnexe + ' m²' : ''}`}>{`${shaAnnexe !== null ? shaAnnexe + ' m²' : ''}`}</span>;
            }
        });
        columnsTempLotCommercial.push({
            key: 'prixTTC',
            name: 'Prix TTC',
            ariaLabel: 'Prix TTC',
            fieldName: 'prixTTC',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let prixTTC = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.prixTTC).toFixed(2), false, 2);

                return (item.prixTTC !== null ? <span title={`${prixTTC} €`}>{`${prixTTC} €`}</span> : null);
            }
        });
        columnsTempLotCommercial.push({
            key: 'prixMaitriseTTC',
            name: 'Prix maîtrisé',
            ariaLabel: 'Prix maîtrisé',
            fieldName: 'prixMaitriseTTC',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let prixMaitriseTTC = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.prixMaitriseTTC).toFixed(2), false, 2);

                return (item.prixMaitriseTTC !== null ? <span title={`${prixMaitriseTTC} €`}>{`${prixMaitriseTTC} €`}</span> : null);
            }
        });
        columnsTempLotCommercial.push({
            key: 'loyerAnnuelTTC',
            name: 'Loyer TTC',
            ariaLabel: 'Loyer TTC',
            fieldName: 'loyerAnnuelTTC',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let loyerAnnuelTTC = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.loyerAnnuelTTC).toFixed(2), false, 2);

                return (item.loyerAnnuelTTC !== null ? <span title={`${loyerAnnuelTTC} €`}>{`${loyerAnnuelTTC} €`}</span> : null);
            }
        });
        columnsTempLotCommercial.push({
            key: 'prixMobilierTTC',
            name: 'Prix mobilier',
            ariaLabel: 'Prix mobilier',
            fieldName: 'prixMobilierTTC',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let prixMobilierTTC = Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(parseFloat(item.prixMobilierTTC).toFixed(2), false, 2);

                return (item.prixMobilierTTC !== null ? <span title={`${prixMobilierTTC} €`}>{`${prixMobilierTTC} €`}</span> : null);
            }
        });
        columnsTempLotCommercial.push({
            key: 'dateAction',
            name: 'Date',
            ariaLabel: 'Date',
            fieldName: 'dateAction',
            minWidth: 50,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let dateAction = Scriba.date().stringDateFormatCourt(item.dateAction);

                return <span title={dateAction}>{dateAction}</span>;
            }
        });
        columnsTempLotCommercial.push({
            key: 'modifier',
            name: '',
            ariaLabel: 'Modifier',
            fieldName: 'modifier',
            minWidth: 20,
            maxWidth: 20,
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                return (this.state.peutModifierOperation && item.idLotCommercial !== null ?
                    <IconButton
                        iconProps={{ iconName: 'Edit' }}
                        title="Modifier"
                        ariaLabel="Modifier"
                        onClick={() => this._onAffichagePanelGrilleDePrix_LotCommercial(item.idLotCommercial, item.statut, 'Edition')}
                    />
                    : null);
            }
        });
        columnsTempLotCommercial.push({
            key: 'ficheChronologique',
            name: '',
            ariaLabel: 'Fiche chronologique',
            fieldName: 'ficheChronologique',
            minWidth: 20,
            maxWidth: 20,
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                return (<IconButton
                    iconProps={{ iconName: 'TimelineProgress' }}
                    title="Fiche chronologique"
                    ariaLabel="Fiche chronologique"
                    onClick={() => this._onAffichagePanelLotCommercialHistorique(item)}
                />);
            }
        });
        columnsTempLotCommercial.push({
            key: 'venteEnBloc',
            name: '',
            ariaLabel: 'Vente en bloc',
            fieldName: 'venteEnBloc',
            minWidth: 20,
            maxWidth: 20,
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                return (item.venteEnBloc ?
                    <IconButton
                        iconProps={{ iconName: 'Tag' }}
                        title="Vente en bloc"
                        ariaLabel="Vente en bloc"
                        onClick={() => (item.statut === 'Pas à la vente' ? alert('Ce lot n\'est pas en vente') : (item.itemProps.group.item.idReservation > 0 ? alert('Ce lot est déjà réservé') : this._onAffichagePanelFicheReservation(item)))}
                    />
                    : null);
            }
        });
        columnsTempLotCommercial.push({
            key: 'desistement',
            name: '',
            ariaLabel: 'Désistement',
            fieldName: 'desistement',
            minWidth: 20,
            maxWidth: 20,
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                let idReservation = item.itemProps.group.item.idReservation;
                return (item.venteEnBloc && idReservation > 0 ?
                    <IconButton
                        iconProps={{ iconName: 'Unsubscribe' }}
                        title="Désistement"
                        ariaLabel="Désistement"
                        onClick={() => this._onAffichageDialogDesistement(item, idReservation)}
                    />
                    : null);
            }
        });

        this.columnsLotCommercial = columnsTempLotCommercial;
        //#endregion
    }

    _getItems = () => {
        let tableauBoutons = [];

        if (this.state.peutModifierOperation) {
            let boutonCreerLot = {
                key: 'creerLot',
                name: 'Créer un lot unitaire',
                iconProps: { iconName: 'Add' },
                onClick: (() => this._onAffichagePanelFicheLot(null))
            }

            tableauBoutons.push(boutonCreerLot);

            let boutonSuppression = {
                key: 'supprimer',
                name: 'Supprimer',
                iconProps: {
                    iconName: 'Delete'
                },
                onClick: (() => this._onAfficheDialogSuppression()),
                disabled: this._selection.getSelectedCount() === 0
            }

            tableauBoutons.push(boutonSuppression);

            let actionsLotsUnitaires = {
                name: 'menuLotsUnitaires',
                key: 'lotsUnitaires',
                text: 'Lots unitaires',
                iconProps: { iconName: 'RealEstate' },
                disabled: this._selection.getSelectedCount() === 0,
                subMenuProps: {
                    items: [
                        {
                            key: 'associerLot',
                            name: 'Associer un/des lots vers un lot commercial',
                            iconProps: { iconName: 'Link' },
                            onClick: (() => this._onAfficheDialogAssocierLot()),
                            disabled: this._selection.getSelectedCount() <= 0
                        },
                        {
                            key: 'dissocierLot',
                            name: 'Dissocier un/des lots unitaires du lot commercial',
                            iconProps: { iconName: 'RemoveLink' },
                            onClick: (() => this._onAfficheDialogDissocierLot()),
                            disabled: this._selection.getSelectedCount() <= 0
                        },
                        {
                            key: 'lierLot',
                            name: 'Lier des lots unitaires',
                            iconProps: { iconName: 'Link' },
                            onClick: (() => this._onAfficheDialogRegrouperLot()),
                            disabled: this._selection.getSelectedCount() <= 1
                        },
                        {
                            key: 'delierLot',
                            name: 'Délier des lots unitaires',
                            iconProps: { iconName: 'RemoveLink' },
                            onClick: (() => this._onAfficheDialogDegrouperLot()),
                            disabled: this._selection.getSelectedCount() <= 0
                        }
                    ]
                }
            }

            tableauBoutons.push(actionsLotsUnitaires);

            let actionsLotsCommerciaux = {
                name: 'menuLotsCommerciaux',
                key: 'lotsCommerciaux',
                text: 'Lots commerciaux',
                iconProps: { iconName: 'CityNext2' },
                disabled: this._selection.getSelectedCount() === 0,
                subMenuProps: {
                    items: [
                        {
                            key: 'mettreVenteLotCommercial',
                            name: 'Mettre un/des lots commerciaux à la vente',
                            iconProps: {
                                iconName: 'DecisionSolid'
                            },
                            onClick: (() => this._onAfficheDialogMiseEnVenteLotsCommerciaux()),
                        },
                        {
                            key: 'retirerVenteLotCommercial',
                            name: 'Retirer un/des lots commerciaux de la vente',
                            iconProps: {
                                iconName: 'NotImpactedSolid'
                            },
                            onClick: (() => this._onAfficheDialogRetirerVenteLotsCommerciaux()),
                        }
                    ]
                }
            }

            tableauBoutons.push(actionsLotsCommerciaux);

            let actionsCalcul = {
                name: 'menuActionsCalcul',
                key: 'calculs',
                text: 'Actions de calcul',
                iconProps: { iconName: 'Calculator' },
                disabled: this._selection.getSelectedCount() === 0,
                subMenuProps: {
                    items: [
                        {
                            name: 'calculPourcentage',
                            key: 'calculPourcentage',
                            text: 'Ajouter / Soustraire un pourcentage',
                            iconProps: { iconName: 'CalculatorPercentage' },
                            onClick: (() => this._onAfficheDialogActionCalcul('Pourcentage')),
                            disabled: this._selection.getSelectedCount() === 0
                        },
                        {
                            key: 'calculValeur',
                            text: 'Ajouter / Soustraire une valeur',
                            iconProps: { iconName: 'NumberField' },
                            onClick: (() => this._onAfficheDialogActionCalcul('Valeur')),
                            disabled: this._selection.getSelectedCount() === 0
                        },
                        {
                            key: 'arrondiSuperieur',
                            text: 'Arrondir à la dizaine supérieure',
                            iconProps: { iconName: 'Up' },
                            onClick: (() => this._onLancementCalculArrondi('ArrondiSup')),
                            disabled: this._selection.getSelectedCount() === 0
                        },
                        {
                            key: 'arrondiInferieur',
                            text: 'Arrondir à la dizaine inférieure',
                            iconProps: { iconName: 'Down' },
                            onClick: (() => this._onLancementCalculArrondi('ArrondiInf')),
                            disabled: this._selection.getSelectedCount() === 0
                        }
                    ]
                }
            }

            tableauBoutons.push(actionsCalcul);

        }

        let comboBoxNature = {
            key: 'nature',
            onRender: () => <ComboBoxNature
                className="comboBoxDansCommandBar"
                label=""
                onChange={(event, option, index, value, item) => this.setState({ filtreIdNature: option.key, nbLotsParNature: 0 })}
                selectedKey={this.state.filtreIdNature}
            />
        }

        tableauBoutons.push(comboBoxNature);

        let boutonSelection = {
            key: 'selectionNature',
            onRender: () => <PrimaryButton onClick={() => this._onSelectionParNature(this.state.filtreIdNature)} className="boutonDansCommandBar">OK</PrimaryButton>
            //onRender: () => <PrimaryButton onClick={() => this._onAffichagePanelFicheDetailLotCommercial({}, true)} disabled={!this.state.filtreNature.id > 0} className="boutonDansCommandBar">OK</PrimaryButton>
        }

        tableauBoutons.push(boutonSelection);

        if (this.state.nbLotsParNature > 0) {
            let divNbLotsParNature = {
                key: 'nbLotsParNature',
                onRender: () => <span>({this.state.nbLotsParNature})</span>
            }

            tableauBoutons.push(divNbLotsParNature);
        }

        if (this.state.peutModifierOperation) {
            let boutonSuppressionLotCommercialVide = {
                key: 'supprimerLotCommercialVide',
                name: 'Suppression Lot Commercial Vide',
                iconProps: {
                    iconName: 'Delete'
                },
                onClick: (() => this.setState({ onAffichePanelSuppressionLotCommercialVide: true })),
                disabled: !this.state.possedeLotCommercialVide
            }

            tableauBoutons.push(boutonSuppressionLotCommercialVide);
        }

        return tableauBoutons;
    }

    _getFarItems = () => {
        return [
            {
                key: 'nombreEnregistrement',
                name: this.state.nbEnregistrement //(this.state.items != null ?  this.state.groupeLotCommercial.length : 0)
            },
            {
                key: 'filtre',
                name: 'Filtres',
                iconProps: {
                    iconName: 'Filter'
                },
                iconOnly: true,
                onClick: () => this._onAffichePanelFiltre()
            }
        ];
    }

    _onInit() {
        this.setState(objetState);
    }

    _chargementDonnees() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement de la grille de prix en cours'
        });

        this._decocherTout();

        let chargementListeGrilleDePrix = DataOperation._chargementGrilleDePrix(this.state.filtreIdLotType, this.state.filtreStatut, this.state.filtreNumLot, this.state.filtreSHA, this.state.filtreEtage, this.state.filtreExposition, this.state.filtreBudget);

        chargementListeGrilleDePrix
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;
                    //let listeItem = objetData[0];
                    //YD : 17/06/2020 : Ajout test sur listeItem != null
                    let items = objetData[0] || [];
                    let groupes = [];
                    let itemsRegroupes = [];

                    // Regroupement par lot commercial
                    if (items.length > 0) {
                        let lotCommercialTrav = items[0];
                        let idLotCommercialTrav = lotCommercialTrav.idLotCommercial;
                        let nomGroupeTrav = lotCommercialTrav.statut;
                        let nbLots = 0;
                        let depart = 0;

                        let idsLotsCommerciaux = [];
                        items.forEach(item => { idsLotsCommerciaux.push(item.idLotCommercial); }); // Récupération de tous les idsLotCommerciaux...
                        const idsLotsCommerciauxUniques = [... new Set(idsLotsCommerciaux)]; // ... puis suppression des doublons

                        idsLotsCommerciauxUniques.forEach(idLotCommercial => {
                            const lotCommercialEtLotsAssocies = items.filter(item => item.idLotCommercial == idLotCommercial);
                            lotCommercialEtLotsAssocies.forEach(item => { itemsRegroupes.push(item); })
                        })

                        itemsRegroupes.forEach((item, index) => {
                            const idLotCommercial = item.idLotCommercial;
                            //idsLotsCommerciaux.push(idLotCommercial); // Inutile ?
                            if (idLotCommercial === idLotCommercialTrav) {
                                nbLots++;
                                if (index === items.length - 1) { // Dernier de la liste
                                    groupes.push({ key: idLotCommercialTrav, name: nomGroupeTrav, startIndex: depart, count: nbLots - 1, isCollapsed: true, item: lotCommercialTrav });
                                }
                            }
                            else {
                                groupes.push({ key: idLotCommercialTrav, name: nomGroupeTrav, startIndex: depart, count: nbLots - 1, isCollapsed: true, item: lotCommercialTrav });

                                lotCommercialTrav = item;
                                idLotCommercialTrav = idLotCommercial;
                                nomGroupeTrav = item.statut;
                                depart = (depart + nbLots) - 1;
                                nbLots = 1;
                            }
                        });
                    }

                    // on retire la ligne correspondant à l'en-tête du lot commercial car elle ne sert qu'à regrouper les lots
                    // + contruction la liste déroulante pour sélection lors de l'association d'un lot à un lot commercial existant
                    let lots = [];
                    let options = [];

                    Immocom.ajoutValeurDefautDansOptionSansTest_Prop_avecValeurDefaut(options, true);

                    itemsRegroupes.forEach(item => {
                        if (item.idLot !== null) {
                            lots.push(item);
                        }
                        else {
                            if (item.idLotCommercial !== null) {
                                options.push({
                                    key: item.idLotCommercial,
                                    text: item.numero,
                                    statut: item.statut
                                });
                            }
                        }
                    });

                    const stateTemp = {
                        items: lots,
                        groupeLotCommercial: groupes,
                        optLotsCommerciaux: options,
                        nbEnregistrement: groupes.length !== 0 ? (groupes[0].key === null ? groupes.length - 1 : groupes.length) : 0,
                        peutModifierOperation: objetData[1],
                        peutVisualiserFicheLotCommercial: objetData[2],
                        peutAssocierLotUnitaireVersLotCommercial: objetData[4],
                        peutDissocierLotUnitaireVersLotCommercial: objetData[5],
                        possedeLotCommercialVide: objetData[3],
                        peutDissocierLotUnitaire: objetData[6]
                    };
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                }
                else {
                    const stateTemp = {
                        items: [],
                        groupeLotCommercial: [],
                        optLotsCommerciaux: [],
                        nbEnregistrement: 0
                    };
                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _onSuppression = () => {
        let lotsSelectionnes = this.state.selectedLots;
        let onPeutModifier = this._onVerificationSuppressionPossible(lotsSelectionnes);

        if (!onPeutModifier) {
            this._onAfficheDialogModificationImpossible('Erreur, vous essayez de supprimer un ou plusieurs lots qui sont définis dans une réservation. Cela est impossible.');
            return;
        }

        this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: 'Suppression en cours' });

        let suppressionLots = DataLotCommercial._onSuppressionLotsCommerciaux(lotsSelectionnes, 'Supprimer');
        suppressionLots
            .then(responseFetch => {
                let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    this._onCacheDialogSuppression();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onMiseEnVenteLotsCommerciaux = (actifVente) => {
        let lotsSelectionnes = this.state.selectedLots;

        let onPeutModifier = this._onVerificationRetirerVentePossible(lotsSelectionnes);

        if (onPeutModifier) {
            this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: 'Mise en vente des lots commerciaux' });

            let miseEnVenteLotsCommerciaux = DataLotCommercial._onMiseEnVenteLotsCommerciaux(lotsSelectionnes, actifVente);

            miseEnVenteLotsCommerciaux
                .then(responseFetch => {
                    let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                    if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                        (actifVente ? this._onCacheDialogMiseEnVenteLotsCommerciaux() : this._onCacheDialogRetirerVenteLotsCommerciaux());
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
        else {
            this._onAfficheDialogModificationImpossible('Erreur, vous essayez de modifier un ou plusieurs lots qui sont définis dans une réservation. Cela est impossible.');
        }
    }

    _onAssociationLots = () => {
        let lotsSelectionnes = this.state.selectedLots;

        let onPeutModifier = this._onVerificationModificationPossible(lotsSelectionnes, 'Associer');
        let estReserve = this._onVerificationEstReserve(lotsSelectionnes);

        if (onPeutModifier) {
            this._onAffichagePanelGrilleDePrix_LotCommercial(this.state.selectedLotCommercial.idLotCommercial, this.state.selectedLotCommercial.statut, this.state.actionAssociation);
        }
        else {
            this._onAfficheDialogModificationImpossible(`Erreur, vous essayez de modifier un ou plusieurs lots qui sont définis dans une réservation${estReserve ? ' verrouillée' : ''} qui n'est plus au stade Initiale. Cela est impossible.`);
        }
    }

    _onDissociationLots = (suppressionLotCommercial) => {
        let lotsSelectionnes = this.state.selectedLots;

        const onPeutModifier = this._onVerificationModificationPossible(lotsSelectionnes, 'Dissocier');
        const estReserve = this._onVerificationEstReserve(lotsSelectionnes);

        if (!onPeutModifier) {
            this._onAfficheDialogModificationImpossible(`Erreur, vous essayez de modifier un ou plusieurs lots qui sont définis dans une réservation${estReserve ? ' verrouillée' : ''} qui n'est plus au stade Initiale. Cela est impossible.`);
            return;
        }

        this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: 'Dissociation des lots' });

        let dissociationLots = DataLot._onDissociationLots(lotsSelectionnes, suppressionLotCommercial);

        dissociationLots.then(responseFetch => {
            let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

            if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                this._selection.setAllSelected(false);
                this._onCacheDialogDissocierLot();
            }
            else {
                Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
            }
        });
    }

    _onDissociationLotsAvecSuppression = (supprime) => {
        this._onCacheDialogDissocierLotEtSupprimerLotCommercial();
        this._onDissociationLots(supprime);
    }

    _onRegroupementLots = () => {
        let lotsSelectionnes = this.state.selectedLots;

        let onPeutModifier = this._onVerificationModificationPossible(lotsSelectionnes, 'Regrouper');

        if (onPeutModifier) {
            this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: 'Regroupement des lots' });

            let regroupementLots = DataLot._onRegroupementLots(lotsSelectionnes);

            regroupementLots
                .then(responseFetch => {
                    let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                    if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                        this._onCacheDialogRegrouperLot();
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
        else {
            this._onAfficheDialogModificationImpossible('Erreur, vous essayez de modifier un ou plusieurs lots qui sont définis dans une réservation. Cela est impossible.');
        }
    }

    _onDegroupementLots = () => {
        let lotsSelectionnes = this.state.selectedLots;

        let onPeutModifier = this._onVerificationModificationPossible(lotsSelectionnes, 'Degrouper');

        if (onPeutModifier) {
            this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: 'Dégroupement des lots' });

            let degroupementLots = DataLot._onDegroupementLots(lotsSelectionnes);

            degroupementLots
                .then(responseFetch => {
                    let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                    if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                        this._onCacheDialogDegrouperLot();
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
        else {
            this._onAfficheDialogModificationImpossible('Erreur, vous essayez de modifier un ou plusieurs lots qui sont définis dans une réservation. Cela est impossible.');
        }
    }

    _onCalculLot = () => {
        let lotsSelectionnes = this.state.selectedLots;
        let actionCalcul = this.state.calculAAppliquer;

        let onPeutModifier = this._onVerificationModificationPossible(lotsSelectionnes);

        if (onPeutModifier) {
            if (actionCalcul.action === 'Pourcentage' && actionCalcul.signe === '-' && actionCalcul.valeur === 100) {
                alert("Erreur, le pourcentage est inférieur à -100%");
            }
            else {
                this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: 'Calcul des lots' });

                let calculPrixLots = DataLot._onCalculPrixLots(lotsSelectionnes, actionCalcul);

                calculPrixLots
                    .then(responseFetch => {
                        let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                        if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                            this._onCacheDialogActionCalcul();
                        }
                        else {
                            Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                        }
                    });
            }
        }
        else {
            this._onAfficheDialogModificationImpossible('Erreur, vous essayez de modifier un ou plusieurs lots qui sont définis dans une réservation. Cela est impossible.');
        }
    }

    _onDesistementReservation = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Désistement de la réservation'
        });

        let onDesistementReservation = DataReservation._onDesistementReservation(this.state.selectedLotCommercial.idOperation, this.state.idReservation, this.state.desistement);

        onDesistementReservation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    this._onCacheDialogDesistement();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onVerificationModificationPossible = (selectionItems, action) => {
        let onPeutModifier = true;
        const lotsCommerciaux = this._getLotsCommerciaux(selectionItems);
        let _this = this;

        lotsCommerciaux.forEach(function (value, index) {
            if (value.idReservation !== null && !_this.state.peutDissocierLotUnitaire) {
                if (value.verrouille === true) {
                    if (!(action === 'Associer' && _this.state.peutAssocierLotUnitaireVersLotCommercial && value.idCycleReservation === 10)) {
                        onPeutModifier = false;
                    }
                    else if (!(action === 'Dissocier' && _this.state.peutDissocierLotUnitaireVersLotCommercial && value.idCycleReservation === 10)) {
                        onPeutModifier = false;
                    }
                }
                else {
                    if (value.idCycleReservation !== 10) {
                        onPeutModifier = false;
                    }
                }
            }
        });

        return onPeutModifier;
    }
    _onVerificationSuppressionPossible = (selectionItems) => {
        let onPeutSupprimer = true;
        const lotsCommerciaux = this._getLotsCommerciaux(selectionItems);

        lotsCommerciaux.forEach(function (value, index) {
            if (value.idReservation !== null)
                onPeutSupprimer = false;
        });

        return onPeutSupprimer;
    }
    _onVerificationRetirerVentePossible = (selectionItems) => {
        let onPeutRetirerVente = true;
        const lotsCommerciaux = this._getLotsCommerciaux(selectionItems);

        lotsCommerciaux.forEach(function (value, index) {
            if (value.idReservation !== null)
                onPeutRetirerVente = false;
        });

        return onPeutRetirerVente;
    }
    _validationFormulaireDesistement(item) {
        let estValide = true;

        // Si l'objet n'est pas vide
        if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
            estValide = estValide && (item.dateDesistement !== '');
            estValide = estValide && (item.motifDesistement !== '');
        }
        else {
            estValide = false;
        }

        return estValide;
    }


    _getLotsCommerciaux = (lots) => {
        if (!lots || lots.length < 1) {
            return [];
        }
        const { groupeLotCommercial } = this.state;
        const listeLotsCommerciaux = lots.reduce((acc, item) => {
            const grpLotCommercial = groupeLotCommercial.find(t => t.item.idLotCommercial === item.idLotCommercial);
            const lotCommercial = grpLotCommercial.item;
            const dejaAjoute = acc.find(it => it.idLotCommercial === lotCommercial.idLotCommercial);
            if (!dejaAjoute) {
                acc.push(lotCommercial);
            }
            return acc;
        }, []);

        return listeLotsCommerciaux;
    }

    // verifie si un lot commercial a tous ses lots sélectionnés pour proposer la suppression du lc
    _onLotCommercialSupprimable() {
        const lotsSelectionnes = this.state.selectedLots;
        const { items } = this.state;
        const lotsCommerciaux = this._getLotsCommerciaux(lotsSelectionnes);
        const tousLotsSelectionnesDunLotCommercial = lotsCommerciaux.some((item) => {
            const grpSelectionnes = lotsSelectionnes.filter(l => l.idLotCommercial === item.idLotCommercial);
            const grpTous = items.filter(l => l.idLotCommercial === item.idLotCommercial);
            return grpSelectionnes.length === grpTous.length;
        });

        return tousLotsSelectionnesDunLotCommercial;
    }

    _onVerificationEstReserve = (listLots) => {
        const lotsCommerciaux = this._getLotsCommerciaux(listLots);
        return lotsCommerciaux.some((item) => item.statut === 'Validé' || item.statut === 'Réservé');
    }

    _onAffichePanelFiltre = () => {
        this.setState({ onAffichePanelFiltre: true });
    }

    _onCachePanelFiltre = () => {
        this.setState({ onAffichePanelFiltre: false });
    }

    _onAffichagePanelGrilleDePrix_LotCommercial = (idLotCommercial, statut, actionAssociation) => {
        this.setState({
            onAffichePanelGrilleDePrix_LotCommercial: true,
            selectedLotCommercial: {
                idLotCommercial: idLotCommercial,
                statut: statut
            },
            actionAssociation: actionAssociation
        });
    }

    _onCachePanelGrilleDePrix_LotCommercial = () => {
        this.setState({ onAffichePanelGrilleDePrix_LotCommercial: false });
        this._chargementDonnees();
    };

    _onAffichagePanelLotCommercialHistorique = (lotCommercial) => {
        this.setState({
            onAffichePanelLotCommercialHistorique: true,
            selectedLotCommercial: {
                idLotCommercial: lotCommercial.idLotCommercial,
                statut: lotCommercial.statut
            }
        });
    }

    _onCachePanelLotCommercialHistorique = () => {
        this.setState({
            onAffichePanelLotCommercialHistorique: false,
            selectedLotCommercial: {}
        });

        this._chargementDonnees();
    };

    _onAffichagePanelFicheLot = (lot) => {
        this.setState({
            onAffichePanelFicheLot: true,
            selectedLot: lot
        });
    }

    _onCachePanelFicheLot = () => {
        this.setState({
            onAffichePanelFicheLot: false,
            selectedLot: {}
        });

        this._chargementDonnees();
    };

    _onAffichagePanelFicheReservation = (lotCommercial) => {
        this.setState({
            onAffichePanelFicheReservation: true,
            selectedLotCommercial: lotCommercial
        });
    }

    _onCachePanelFicheReservation = () => {
        this.setState({
            onAffichePanelFicheReservation: false,
            selectedLotCommercial: {}
        });

        this._chargementDonnees();
    };

    _onAffichePanelSuppressionLotCommercialVide = () => {
        //if (estadminNat)
        this.setState({
            onAffichePanelSuppressionLotCommercialVide: true
        });
    }

    _onCachePanelSuppressionLotCommercialVide = () => {
        this.setState({
            onAffichePanelSuppressionLotCommercialVide: false
        }, this._chargementDonnees);
    };

    _onAfficheDialogSuppression = () => {
        this.setState({ onAfficheDialogSuppression: true });
    };

    _onCacheDialogSuppression = () => {
        this.setState({ onAfficheDialogSuppression: false });
        this._chargementDonnees();
    };

    _onAffichePanelSuppression = () => {
        this.setState({ onAffichePanelSuppressionLotCommercialVide: true });
    };

    _onCachePanelSuppression = () => {
        this.setState({ onAffichePanelSuppressionLotCommercialVide: false });
        this._chargementDonnees();
    };

    _onAfficheDialogMiseEnVenteLotsCommerciaux = () => {
        this.setState({ onAfficheDialogMiseEnVenteLotsCommerciaux: true });
    };

    _onCacheDialogMiseEnVenteLotsCommerciaux = () => {
        this.setState({ onAfficheDialogMiseEnVenteLotsCommerciaux: false });
        this._chargementDonnees();
    };

    _onAfficheDialogRetirerVenteLotsCommerciaux = () => {
        this.setState({ onAfficheDialogRetirerVenteLotsCommerciaux: true });
    };

    _onCacheDialogRetirerVenteLotsCommerciaux = () => {
        this.setState({ onAfficheDialogRetirerVenteLotsCommerciaux: false });
        this._chargementDonnees();
    };

    _onAfficheDialogAssocierLot = () => {
        this.setState({
            onAfficheDialogAssocierLot: true,
            selectedLotCommercial: { idLotCommercial: 0, statut: null }
        });
    };

    _onCacheDialogAssocierLot = () => {
        this.setState({ onAfficheDialogAssocierLot: false, actionAssociation: 'Nouveau', selectedLotCommercial: {} });
        this._chargementDonnees();
    };

    _onAfficheDialogDissocierLot = () => {
        this.setState({ onAfficheDialogDissocierLot: true });
    };

    _onCacheDialogDissocierLot = () => {
        this.setState({ onAfficheDialogDissocierLot: false });
        this._chargementDonnees();
    };

    _onAfficheDialogDissocierLotEtSupprimerLotCommercial = () => {
        // Si au moins un lots commercial a tous ses lots sélectionnés
        const afficherPopinSuppression = this._onLotCommercialSupprimable();
        if (afficherPopinSuppression === true)
            this.setState({ onAfficheDialogDissocierLotEtSupprimerLotCommercial: true });
        else
            this._onDissociationLots(false);
    };

    _onCacheDialogDissocierLotEtSupprimerLotCommercial = () => {
        this.setState({ onAfficheDialogDissocierLotEtSupprimerLotCommercial: false });
        this._chargementDonnees();
    };

    _onAfficheDialogRegrouperLot = () => {
        this.setState({ onAfficheDialogRegrouperLot: true });
    };

    _onCacheDialogRegrouperLot = () => {
        this.setState({ onAfficheDialogRegrouperLot: false });
        this._chargementDonnees();
    };

    _onAfficheDialogDegrouperLot = () => {
        this.setState({ onAfficheDialogDegrouperLot: true });
    };

    _onCacheDialogDegrouperLot = () => {
        this.setState({ onAfficheDialogDegrouperLot: false });
        this._chargementDonnees();
    };

    _onAfficheDialogActionCalcul = (action) => {
        let calculAAppliquerTrav = { ...this.state.calculAAppliquer };
        calculAAppliquerTrav.action = action;

        this.setState({ onAfficheDialogActionCalcul: true, calculAAppliquer: calculAAppliquerTrav });
    };

    _onCacheDialogActionCalcul = () => {
        this.setState({ onAfficheDialogActionCalcul: false, calculAAppliquer: { signe: '+', valeur: 0, action: 'Valeur' } });
        this._chargementDonnees();
    };

    _onAfficheDialogModificationImpossible = (message) => {
        this.setState({ onAfficheDialogModificationImpossible: true, messageModificationImpossible: message });
    };

    _onCacheDialogModificationImpossible = () => {
        this.setState({ onAfficheDialogModificationImpossible: false });
    };

    _onAffichageDialogDesistement = (lotCommercial, idReservation) => {
        this.setState({ onAfficheDialogDesistement: true, selectedLotCommercial: lotCommercial, idReservation: idReservation });
    }
    _onCacheDialogDesistement = () => {
        this.setState({ onAfficheDialogDesistement: false, selectedLotCommercial: {}, idReservation: 0 });
        this._chargementDonnees();
    };

    _onLancementCalculArrondi = (nomAction) => {
        this.setState({ calculAAppliquer: { signe: '', valeur: 0, action: nomAction } }, function () {
            this._onCalculLot();
        });
    }

    _onSelectionParNature = (idNature) => {
        let selectionTrav = this._selection;
        let nb = 0;
        let headerGroupsTrav = this._headerGroups;
        let groupesTrav = [];

        // on décoche tout
        this._decocherTout();

        // on ferme tout
        headerGroupsTrav.forEach(function (v, i) {
            v.itemProps.group.isCollapsed = true;
        });

        if (idNature > 0) {
            this.state.items.forEach(function (value, index) {
                if (value.idNature === idNature) {
                    // on sélectionne le lot
                    selectionTrav.setIndexSelected(index, true, false);
                    nb++;

                    headerGroupsTrav.forEach(function (v, i) {
                        if (v.idLotCommercial === value.idLotCommercial) {
                            // on ouvre le groupe
                            v.itemProps.group.isCollapsed = false;
                        }

                        // on reconstruit la liste des groupes pour màj de la liste
                        groupesTrav.push(v.itemProps.group);
                    });
                }
            });

            this.setState({ nbLotsParNature: nb, groupeLotCommercial: groupesTrav });
        }
        else {
            this.setState({ nbLotsParNature: nb });
        }
    }

    _decocherTout() {
        this._selection.setAllSelected(false);
    }

    _onFiltreTableau = () => {
        this._chargementDonnees();
        this._onCachePanelFiltre();
    }

    _reinitFiltre = () => {
        this.setState({
            filtreIdLotType: 0,
            filtreStatut: '0',
            filtreNumLot: null,
            filtreSHA: 300,
            filtreEtage: 0,
            filtreExposition: 0,
            filtreBudget: 1000000
        });
    }

    _onRenderGroupHeader = (props) => {
        if (props) {
            let lotCommercialTrav = props.group.item;
            let itemGroup = {
                itemProps: props,
                idOperation: lotCommercialTrav.idOperation,
                idLotCommercial: lotCommercialTrav.idLotCommercial,
                statut: lotCommercialTrav.statut,
                numero: lotCommercialTrav.numero,
                lotType: lotCommercialTrav.lotType,
                etage: lotCommercialTrav.etage,
                nbParking: lotCommercialTrav.nbParking,
                nbCave: lotCommercialTrav.nbCave,
                shaTotale: lotCommercialTrav.shaTotale,
                shaAnnexe: lotCommercialTrav.shaAnnexe,
                prixTTC: lotCommercialTrav.prixTTC,
                prixMaitriseTTC: lotCommercialTrav.prixMaitriseTTC,
                loyerAnnuelTTC: lotCommercialTrav.loyerAnnuelTTC,
                prixMobilierTTC: lotCommercialTrav.prixMobilierTTC,
                dateAction: lotCommercialTrav.dateAction,
                verrouille: lotCommercialTrav.verrouille,
                venteEnBloc: lotCommercialTrav.venteEnBloc
            };

            // construction d'une liste pour récupérer les groupes avec leurs props utilisée dans _onSelectionParNature
            if (this._headerGroups.find(i => i.idLotCommercial === itemGroup.idLotCommercial) === undefined) {
                this._headerGroups.push(itemGroup);
            }

            return (lotCommercialTrav.idLotCommercial !== null ?
                <DetailsList
                    items={[itemGroup]}
                    isHeaderVisible={false}
                    compact={true}
                    layoutMode={DetailsListLayoutMode.justified}
                    columns={this.columnsLotCommercial}
                    selectionMode={SelectionMode.none}
                    onRenderRow={this._onRenderRow}
                />
                :
                <div className="enteteLotCommercial">
                    <div className="titreEnteteLotCommercial">
                        {props.isSelected ?
                            <IconButton
                                iconProps={{ iconName: 'Completed' }}
                                title="Désélectionner tout"
                                ariaLabel="Désélectionner tout"
                                onClick={this._onToggleSelectGroup(props)}
                            />
                            :
                            <IconButton
                                iconProps={{ iconName: 'CircleRing' }}
                                title="Sélectionner tout"
                                ariaLabel="Sélectionner tout"
                                onClick={this._onToggleSelectGroup(props)}
                            />
                        }
                        {props.group.isCollapsed ?
                            <IconButton
                                iconProps={{ iconName: 'ChevronRightMed' }}
                                title="Déplier"
                                ariaLabel="Déplier "
                                onClick={this._onToggleCollapse(props)}
                            />
                            :
                            <IconButton
                                iconProps={{ iconName: 'ChevronDownMed' }}
                                title="Replier"
                                ariaLabel="Replier"
                                onClick={this._onToggleCollapse(props)}
                            />
                        }
                        <span>{`${props.group.name} (${props.group.count})`}</span>
                    </div>
                </div>
            );
        }

        return null;
    };

    _onToggleSelectGroup(props) {
        return () => {
            props.onToggleSelectGroup(props.group);
        };
    }

    _onToggleCollapse(props) {
        return () => {
            props.onToggleCollapse(props.group);
        };
    }

    _onRenderDetailsHeader(props, defaultRender) {
        return (
            <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
                {defaultRender({
                    ...props,
                    onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
                })}
            </Sticky>
        );
    }

    _onRenderRow = (props) => {
        const customStyles = {};

        if (props) {
            customStyles.root = { backgroundColor: theme.palette.neutralLighterAlt }; //#f8f8f8

            return <span data-selection-disabled={true}><DetailsRow {...props} styles={customStyles} /></span>;
        }

        return null;
    };

    _onRenderFooterFiltresContent = () => {
        return (
            <div>
                <PrimaryButton onClick={this._onFiltreTableau} className="marginRight8px">Valider</PrimaryButton>
                <DefaultButton onClick={this._onCachePanelFiltre}>Fermer</DefaultButton>
            </div>
        );
    }

    componentDidMount() {
        this._chargementDonnees();
    }

    //componentDidUpdate() {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");

    //        this._chargementDonnees();
    //    }
    //}

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this._chargementDonnees();
    };

    render = () => {

        const content = this._creationContent();
        const boutonActif = this._validationFormulaireDesistement(this.state.desistement);

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                    farItems={this._getFarItems()}
                    ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <Panel
                isOpen={this.state.onAffichePanelFiltre}
                type={PanelType.smallFixedFar}
                onDismiss={this._onCachePanelFiltre}
                headerText="Filtres"
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterFiltresContent}
            >
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="buttonFiltres">
                            <IconButton
                                iconProps={{ iconName: 'ClearFilter' }}
                                className="buttonFiltres"
                                title="Réinitialiser les filtres"
                                ariaLabel="Filtres"
                                onClick={() => this._reinitFiltre()}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <ComboBoxLotType
                                idNature={1}
                                onChange={(event, option) => this.setState({ filtreIdLotType: option.key })}
                                selectedKey={this.state.filtreIdLotType}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <EUIComboBox
                                idValeurParDefaut="0"
                                label="Statut"
                                onChange={(event, option) => this.setState({ filtreStatut: option.key })}
                                options={[
                                    { key: 'En stock', text: 'En stock' },
                                    { key: 'Validé', text: 'Validé' },
                                    { key: 'Réservé', text: 'Réservé' },
                                    { key: 'Optionné', text: 'Optionné' },
                                    { key: 'Pas à la vente', text: 'Pas à la vente' }
                                ]}
                                selectedKey={this.state.filtreStatut}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <EUITextField
                                label="N° de lot"
                                maxLength={MaxLengths.lot.numero}
                                onChange={(event, newValue) => this.setState({ filtreNumLot: newValue })}
                                value={this.state.filtreNumLot}
                            />
                        </div>
                    </div>
                    <div className="separateur"></div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <Slider
                                label="Surface habitable jusqu'à"
                                min={0}
                                max={300}
                                step={5}
                                defaultValue={this.state.filtreSHA}
                                showValue={true}
                                valueFormat={(value) => (value === 300 ? 'Toutes' : Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(value, false, 0) + ' m²')}
                                onChange={(value) => this.setState({ filtreSHA: value })}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <ComboBoxEtage
                                onChange={(event, option, index, value, item) => this.setState({ filtreEtage: option.key })}
                                selectedKey={this.state.filtreEtage}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <ComboBoxExposition
                                onChange={(event, option, index, value, item) => this.setState({ filtreExposition: option.key })}
                                selectedKey={this.state.filtreExposition}
                            />
                        </div>
                    </div>
                    <div className="separateur"></div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <Slider
                                label="Budget jusqu'à"
                                min={0}
                                max={1000000}
                                step={10000}
                                defaultValue={this.state.filtreBudget}
                                showValue={true}
                                valueFormat={(value) => (value === 1000000 ? 'Tous' : Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(value, false, 0) + ' €')}
                                onChange={(value) => this.setState({ filtreBudget: value })}
                            />
                        </div>
                    </div>
                </div>
            </Panel>

            <Dialog
                hidden={!this.state.onAfficheDialogSuppression}
                onDismiss={this._onCacheDialogSuppression}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Suppression',
                    subText: 'Etes-vous certain de vouloir supprimer les lots sélectionnés ?'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton name="btnValiderSuppression" onClick={() => this._onSuppression()} text="Valider" />
                    <DefaultButton onClick={() => this._onCacheDialogSuppression()} text="Annuler" />
                </DialogFooter>
            </Dialog>

            <Dialog
                hidden={!this.state.onAfficheDialogMiseEnVenteLotsCommerciaux}
                onDismiss={this._onCacheDialogMiseEnVenteLotsCommerciaux}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Mise en vente',
                    subText: 'Etes-vous certain de vouloir mettre en vente les lots sélectionnés ?'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton name="btnValiderMettreEnVente" onClick={() => this._onMiseEnVenteLotsCommerciaux(true)} text="Valider" />
                    <DefaultButton onClick={() => this._onCacheDialogMiseEnVenteLotsCommerciaux()} text="Annuler" />
                </DialogFooter>
            </Dialog>

            <Dialog
                hidden={!this.state.onAfficheDialogRetirerVenteLotsCommerciaux}
                onDismiss={this._onCacheDialogRetirerVenteLotsCommerciaux}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Retirer de la vente',
                    subText: 'Etes-vous certain de vouloir retirer de la vente les lots sélectionnés ?'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton name="btnValiderRetirerDeVente" onClick={() => this._onMiseEnVenteLotsCommerciaux(false)} text="Valider" />
                    <DefaultButton onClick={() => this._onCacheDialogRetirerVenteLotsCommerciaux()} text="Annuler" />
                </DialogFooter>
            </Dialog>

            <Dialog
                hidden={!this.state.onAfficheDialogAssocierLot}
                onDismiss={this._onCacheDialogAssocierLot}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Associer un/des lots unitaires vers un lot commercial',
                    subText: 'Etes-vous certain de vouloir associer les lots sélectionnés ?'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <ChoiceGroup
                    label="Que souhaitez-vous faire ?"
                    required={true}
                    defaultSelectedKey="Nouveau"
                    options={[
                        { key: 'Nouveau', text: 'Créer un nouveau lot commercial' },
                        { key: 'Existant', text: 'Associer à un lot commercial existant' }
                    ]}
                    onChange={(e, opt) => {
                        let state = { actionAssociation: opt.key };
                        if (opt.key === "Nouveau")
                            state.selectedLotCommercial = { idLotCommercial: 0, statut: null };
                        this.setState(state);
                    }}
                />

                {this.state.actionAssociation === 'Existant' ?
                    <EUIComboBox
                        label="Lot commercial"
                        onChange={(event, option) => this.setState({ selectedLotCommercial: { idLotCommercial: option.key, statut: option.statut } })}
                        options={this.state.optLotsCommerciaux}
                        required
                        selectedKey={this.state.selectedLotCommercial.idLotCommercial}
                    />
                    : null
                }

                <DialogFooter>
                    <PrimaryButton name="btnAssociationLots" onClick={() => this._onAssociationLots()} disabled={this.state.actionAssociation === 'Existant' && this.state.selectedLotCommercial.idLotCommercial <= 0} text="Valider" />
                    <DefaultButton onClick={() => this._onCacheDialogAssocierLot()} text="Annuler" />
                </DialogFooter>
            </Dialog>

            <Dialog
                hidden={!this.state.onAfficheDialogDissocierLot}
                //onDismiss={this._onCacheDialogDissocierLot} // KP (04/09/2020) : onDismiss jamais appelée (pas de closeButton + pas de light dismiss)
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Dissocier des lots unitaires d\'un lot commercial',
                    subText: 'Etes-vous certain de vouloir dissocier les lots sélectionnés ?'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton
                        name="btnValiderDissocierLot"
                        onClick={() => {
                            //this._onCacheDialogDissocierLot(); // KP (04/09/2020) : correction bug selectedLots empty
                            this._onAfficheDialogDissocierLotEtSupprimerLotCommercial();
                        }}
                        text="Valider"
                    />
                    <DefaultButton onClick={this._onCacheDialogDissocierLot} text="Annuler" />
                </DialogFooter>
            </Dialog>

            <Dialog
                hidden={!this.state.onAfficheDialogDissocierLotEtSupprimerLotCommercial}
                onDismiss={this._onCacheDialogDissocierLotEtSupprimerLotCommercial}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Suppression d\'un lot commercial après dissociation de tous ses lots',
                    subText: 'Après dissociation des lots, souhaitez-vous supprimer le lot commercial ?'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton
                        name="btnDissociationLotsAvecSuppression"
                        onClick={() =>
                            this._onDissociationLotsAvecSuppression(true)
                        } text="Oui" />
                    <DefaultButton onClick={() =>
                        this._onDissociationLotsAvecSuppression(false)
                    } text="Non" />
                </DialogFooter>
            </Dialog>

            <Dialog
                hidden={!this.state.onAfficheDialogRegrouperLot}
                onDismiss={this._onCacheDialogRegrouperLot}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Lier des lots unitaires',
                    subText: 'Etes-vous certain de vouloir regrouper les lots sélectionnés ?'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={() => this._onRegroupementLots()} text="Valider" />
                    <DefaultButton onClick={() => this._onCacheDialogRegrouperLot()} text="Annuler" />
                </DialogFooter>
            </Dialog>

            <Dialog
                hidden={!this.state.onAfficheDialogDegrouperLot}
                onDismiss={this._onCacheDialogDegrouperLot}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Délier des lots unitaires',
                    subText: 'Etes-vous certain de vouloir dégrouper les lots sélectionnés ?'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton name="btnDegroupementLots" onClick={() => this._onDegroupementLots()} text="Valider" />
                    <DefaultButton onClick={() => this._onCacheDialogDegrouperLot()} text="Annuler" />
                </DialogFooter>
            </Dialog>

            <Dialog
                hidden={!this.state.onAfficheDialogActionCalcul}
                onDismiss={this._onCacheDialogActionCalcul}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: `Ajouter / Soustraire ${this.state.calculAAppliquer.action === 'Pourcentage' ? 'un pourcentage' : 'une valeur'}`,
                    subText: 'Veuillez saisir une valeur'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <ChoiceGroup
                    label="Que souhaitez-vous faire ?"
                    required={true}
                    defaultSelectedKey="+"
                    options={[
                        { key: '+', text: 'Ajouter', iconProps: { iconName: 'CalculatorAddition' } },
                        { key: '-', text: 'Soustraire', iconProps: { iconName: 'CalculatorSubtract' } }
                    ]}
                    onChange={(e, opt) => Scriba.state().setObjetPropriete(this, 'calculAAppliquer', 'signe', opt.key)}
                />
                <TextField // Note KP : TextFieldNombre en cours de test
                    data-testid="inputValeur"
                    required={true}
                    disabled={this.state.calculAAppliquer.signe === null}
                    value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'calculAAppliquer', 'valeur', false, 2)}
                    onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'calculAAppliquer', 'valeur')}
                    onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'calculAAppliquer', 'valeur', e.target.value)}
                    onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'valeur', e, false, 2)}
                    deferredValidationTime={0}
                    prefix={this.state.calculAAppliquer.signe}
                    suffix={this.state.calculAAppliquer.action === 'Pourcentage' ? '%' : null}
                />
                <DialogFooter>
                    <PrimaryButton name="btnValiderPourcentage" onClick={() => this._onCalculLot()} text="Valider" />
                    <DefaultButton onClick={() => this._onCacheDialogActionCalcul()} text="Fermer" />
                </DialogFooter>
            </Dialog>

            <Dialog
                hidden={!this.state.onAfficheDialogModificationImpossible}
                onDismiss={this._onCacheDialogModificationImpossible}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Modification impossible',
                    subText: this.state.messageModificationImpossible
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={() => this._onCacheDialogModificationImpossible()} text="Fermer" />
                </DialogFooter>
            </Dialog>

            <Dialog
                hidden={!this.state.onAfficheDialogDesistement}
                onDismiss={this._onCacheDialogDesistement}
                dialogContentProps={{
                    type: DialogType.largeHeader,
                    title: 'Désistement',
                    subText: 'Veuillez renseigner une date et un motif.'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                            <EUIDatePicker
                                isRequired
                                onSelectDate={date => Scriba.state().setObjetPropriete(this, "desistement", "dateDesistement", Scriba.date().getChaineISOFromDate(date))}
                                placeholder="Date"
                                value={this.state.desistement.dateDesistement}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                            <EUIComboBox
                                label="Motif"
                                onChange={(event, option) => Scriba.state().setObjetPropriete(this, "desistement", "motifDesistement", option.key)}
                                options={[
                                    { key: "Délai de rétractation légal", text: "Délai de rétractation légal" },
                                    { key: "Refus de prêt", text: "Refus de prêt" },
                                    { key: "Offre de prêt caduc", text: "Offre de prêt caduc" },
                                    { key: "Autre", text: "Autre" }
                                ]}
                                required
                                selectedKey={this.state.desistement.motifDesistement}
                            />
                        </div>
                    </div>
                </div>
                <DialogFooter>
                    <PrimaryButton disabled={!boutonActif} onClick={() => this._onDesistementReservation()} text="Désister" />
                    <DefaultButton onClick={this._onCacheDialogDesistement} text="Annuler" />
                </DialogFooter>
            </Dialog>

            <FicheGrilleDePrixLotCommercial
                idLotCommercial={this.state.selectedLotCommercial.idLotCommercial}
                statut={this.state.selectedLotCommercial.statut}
                actionAssociation={this.state.actionAssociation}
                listeLots={this.state.selectedLots}
                onCacheDialogAssocierLot={() => this._onCacheDialogAssocierLot()}
                onAffichePanelGrilleDePrix_LotCommercial={this.state.onAffichePanelGrilleDePrix_LotCommercial}
                onFermeFicheGrilleDePrix_LotCommercial={() => this._onCachePanelGrilleDePrix_LotCommercial()}
            />

            <FicheLotCommercialHistorique
                idLotCommercial={this.state.selectedLotCommercial.idLotCommercial}
                onAffichePanelLotCommercialHistorique={this.state.onAffichePanelLotCommercialHistorique}
                onFermeFicheLotCommercialHistorique={() => this._onCachePanelLotCommercialHistorique()}
            />

            <FicheLot
                idLot={this.state.selectedLot !== null ? this.state.selectedLot.idLot : 0}
                onAffichePanelFicheLot={this.state.onAffichePanelFicheLot}
                onFermeFicheLot={() => this._onCachePanelFicheLot()}
            />

            <FicheReservation
                onAffichePanelReservation={this.state.onAffichePanelFicheReservation}
                idReservation={0}
                idOperation={this.state.selectedLotCommercial.idOperation}
                idLotCommercial={this.state.selectedLotCommercial.idLotCommercial}
                onFermeFicheReservation={() => this._onCachePanelFicheReservation()}
            />

            <FicheLotCommercialSuppression
                onAffiche={this.state.onAffichePanelSuppressionLotCommercialVide}
                onFerme={this._onCachePanelSuppressionLotCommercialVide}
                items={this.state.lotsCommerciauxVide}
            />
        </Fragment>;
    }
}